import { createReducer } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { MentorshipProgramGuideSchema, MentorshipProgramGuidesSchema } from 'redux/schemas/api/mentoring-program-guides';
import {
  getMentorshipProgramGuides,
  getMentorshipProgramGuide,
  createMentorshipProgramGuide,
  updateMentorshipProgramGuide,
  deleteMentorshipProgramGuide,
} from 'redux/actions/mentoring-program-guides';
import { RootState } from 'redux/schemas';
import { mergeWith } from 'lodash';
import { replaceArrays } from 'shared/lodash-utils';
import { initialRootState } from '.';

const singleGuideReducer = (state: RootState, action) => {
  const normalized = normalize(action.payload, MentorshipProgramGuideSchema);

  mergeWith(state.models, normalized.entities, replaceArrays);
};

export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(getMentorshipProgramGuides.fulfilled, (state, action) => {
      const normalized = normalize(action.payload, MentorshipProgramGuidesSchema);

      // Replace (not merge) so guides from a previously-visited program don't
      // accumulate alongside guides from the current program.
      state.models.mentorshipProgramGuides = normalized.entities.mentorshipProgramGuides ?? {};
    })
    .addCase(getMentorshipProgramGuide.fulfilled, singleGuideReducer)
    .addCase(createMentorshipProgramGuide.fulfilled, singleGuideReducer)
    .addCase(updateMentorshipProgramGuide.fulfilled, singleGuideReducer)
    .addCase(deleteMentorshipProgramGuide.fulfilled, (state, action) => {
      const { guideId } = action.meta.arg;

      delete state.models.mentorshipProgramGuides[guideId];
    });
});
